import { AxiosResponse } from "axios";
import { CompanyState } from "./companyStore.reducer";
import { CompanyDispatch } from "./companyStore";
import {
  getCompanyImg,
  updateCompanyImg,
} from "services/firebase/firebase.service";
import { Api } from "services/api/api.service";
import {
  CompanyDto,
  CompanyRequestDto,
  CompanyStampClockResponse,
  CompanyUserRequestDto,
  StampClockTemplate,
  UserRoleRequest,
} from "model/Company";

const saveCompany =
  (dispatch: CompanyDispatch) =>
  (
    company: CompanyRequestDto,
    companies: CompanyDto[],
    companyId?: number
  ): Promise<AxiosResponse<CompanyDto>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = Api()
      .company.addOrUpdateCompany(company, companyId)
      .then((res) => {
        dispatch({
          type: "UPDATE_COMPANY_INFORMATION",
          payload: {
            ...res.data,
            //registrationNumber is null in response
            registrationNumber: company.registrationNumber,
          },
        });
        if (companyId) {
          const newCompanies = companies.map((currentCompany: CompanyDto) =>
            currentCompany.id === companyId ? res.data : currentCompany
          );
          dispatch({
            type: "UPDATE_COMPANIES",
            payload: newCompanies,
          });
        } else {
          dispatch({
            type: "UPDATE_COMPANIES",
            payload: [...companies, res.data],
          });
        }

        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating company", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });

    dispatch({ type: "SET_IS_LOADING", payload: false });
    return res;
  };

const switchCompany =
  (dispatch: CompanyDispatch) => (company: CompanyDto, companyId?: number) => {
    dispatch({ type: "SET_IS_LOADING", payload: true });
    dispatch({
      type: "UPDATE_COMPANY_INFORMATION",
      payload: company,
    });
    dispatch({ type: "SET_IS_LOADING", payload: false });
  };

const getCompany = (dispatch: CompanyDispatch) => async () => {
  dispatch({ type: "SET_IS_LOADING", payload: true });
  // const authState = useAuthState();
  // const updatedCompanyProfile = await api.company
  //   .getCompany(authState.firestoreUser.uid)
  //   .then((res) => res.data)
  //   .catch((e: Error) => {
  //     console.error('Error when updating company', e);
  //     dispatch({
  //       type: 'SET_REQUEST_ERROR',
  //       payload: { message: '', err: e },
  //     });
  //   });

  // updatedCompanyProfile &&
  //   dispatch({
  //     type: 'UPDATE_COMPANY_INFORMATION',
  //     payload: updatedCompanyProfile,
  // });
  dispatch({ type: "SET_IS_LOADING", payload: false });
};

const getCompanyImage =
  (dispatch: CompanyDispatch) =>
  async (companyId: number): Promise<any> => {
    dispatch({ type: "SET_IMAGE_IS_LOADING", payload: true });

    getCompanyImg(companyId)
      .then((res) => {
        dispatch({
          type: "GET_COMPANY_IMAGE",
          payload: res,
        });
        dispatch({ type: "SET_IMAGE_IS_LOADING", payload: false });
      })
      .catch((e: Error) => {
        console.error("Error when updating company", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        dispatch({ type: "SET_IMAGE_IS_LOADING", payload: false });
      });
  };

const updateCompanyImage =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, file: File): Promise<any> => {
    dispatch({ type: "SET_IMAGE_IS_LOADING", payload: true });

    return updateCompanyImg(companyId, file)
      .then(() => {
        dispatch({ type: "SET_IMAGE_IS_LOADING", payload: false });
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when updating company", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        dispatch({ type: "SET_IMAGE_IS_LOADING", payload: false });
        return Promise.reject();
      });
  };

const addCompanyFavorite =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, workerId: number): Promise<any> => {
    return Api()
      .company.addCompanyFavorites(companyId, workerId)
      .then((res) => {
        dispatch({ type: "ADD_COMPANY_FAVORITE", payload: res.data });
        return Promise.resolve();
      })
      .catch((e: any) => {
        console.error("Error when adding favorite", e);
        let errorMessage = e.message;

        if (e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const addCompanyUser =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, user: CompanyUserRequestDto): Promise<any> => {
    return Api()
      .company.addCompanyUser(companyId, user)
      .then((res) => {
        dispatch({ type: "UPDATE_COMPANY_USERS", payload: res.data });
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when adding company User", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const updateCompanyUser =
  (dispatch: CompanyDispatch) =>
  async (
    companyId: number,
    userId: number,
    firebaseId: string,
    role: UserRoleRequest,
    firstName: string,
    lastName: string
  ): Promise<any> => {
    return Api()
      .company.updateCompanyUser(
        companyId,
        userId,
        firebaseId,
        role,
        firstName,
        lastName
      )
      .then((res) => {
        console.log(res);
        dispatch({ type: "UPDATE_COMPANY_USERS", payload: res.data });
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when uppdating company User", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const getAvailableTimeReportsForStamping =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, workerPhoneNumber: string): Promise<any> => {
    return Api()
      .company.getAvailableTimeReportsForStamping(companyId, workerPhoneNumber)
      .then((res) => {
        dispatch({ type: "GET_TIME_REPORT_FOR_STAMPING", payload: res.data });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when getting time report", e);
        let errorMessage = e.message;

        if (e.response && e.response.data && e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const getStampClockTemplate =
  (dispatch: CompanyDispatch) =>
  async (companyId: number): Promise<any> => {
    return Api()
      .company.getStampClockTemplate(companyId)
      .then((res) => {
        console.log(res);

        dispatch({ type: "GET_STAMP_CLOCK_TEMPLATE", payload: res.data });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when getting template", e);
      });
  };

const updateStampClockTemplate =
  (dispatch: CompanyDispatch) =>
  async (data: StampClockTemplate): Promise<any> => {
    return Api()
      .company.updateStampClockTemplate(data)
      .then((res) => {
        console.log(res);
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when uppdating stamp clock template", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const getLocalStampClockOnlySetting =
  (dispatch: CompanyDispatch) =>
  async (companyId: number): Promise<any> => {
    return Api()
      .company.getLocalStampClockOnlySetting(companyId)
      .then((res) => {
        console.log(res);

        dispatch({
          type: "GET_STAMP_CLOCK_LOCAL_ONLY_SETTING",
          payload: res.data,
        });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when getting local only stamp clock setting", e);
      });
  };

const createAutoGeneratedGig =
  (dispatch: CompanyDispatch) =>
  async (
    companyId: number,
    workerPhoneNumber: string,
    data: any
  ): Promise<any> => {
    return Api()
      .company.createAutoGeneratedGig(companyId, workerPhoneNumber, data)
      .then((res) => {
        dispatch({ type: "GET_TIME_REPORT_FOR_STAMPING", payload: res.data });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when creating auto generated gig", e);
        let errorMessage = e.message;

        if (e.response && e.response.data && e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const updateStampClockLocalOnlySetting =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, active: boolean): Promise<any> => {
    return Api()
      .company.updateLocalStampClockOnlySetting(companyId, active)
      .then((res) => {
        console.log(res);
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when uppdating stamp clock local only setting", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const getAutogenerateShiftSetting =
  (dispatch: CompanyDispatch) =>
  async (companyId: number): Promise<any> => {
    return Api()
      .company.getAutogenerateShiftSetting(companyId)
      .then((res) => {
        console.log(res);

        dispatch({
          type: "GET_ALLOW_AUTOGENERATE_SHIFT_SETTING",
          payload: res.data,
        });
        return res.data;
      })
      .catch((e: any) => {
        console.error(
          "Error when getting allow autogenerate shifts setting",
          e
        );
        let errorMessage = e.message;

        if (e.response && e.response.data && e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const getWorkerDetailsByWorkerId =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, workerId: number): Promise<any> => {
    return Api()
      .company.getWorkerDetailsByWorkerId(companyId, workerId)
      .then((res) => {
        console.log(res);

        dispatch({
          type: "GET_WORKER_DETAILS",
          payload: res.data,
        });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when getting worker details", e);
        let errorMessage = e.message;

        if (e.response && e.response.data && e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const updateAutogenerateShiftSetting =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, active: boolean): Promise<any> => {
    return Api()
      .company.updateAutogenerateShiftSetting(companyId, active)
      .then((res) => {
        console.log(res);
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error(
          "Error when uppdating allow autogenerate shift setting",
          e
        );
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const handleCheckInCheckOut =
  (dispatch: CompanyDispatch) =>
  async (
    companyId: number,
    timeReportId: number,
    workerPhoneNumber: string,
  ): Promise<CompanyStampClockResponse> => {
    return Api()
      .company.handleCheckInCheckOut(
        companyId,
        timeReportId,
        workerPhoneNumber,
      )
      .then((res) => {
        console.log(res);
        dispatch({ type: "HANDLE_CHECKIN_CHECKOUT_USER", payload: res.data });
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error handling checking", e);
        let errorMessage = e.message;

        if (e.response.data.errorMessage) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });
        return Promise.reject(e);
      });
  };

const handleDeleteCalenderShift =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, shiftId: number, gigId: string): Promise<any> => {
    return Api()
      .company.deleteCompaniesGigsShift(companyId, shiftId, gigId)
      .then((res) => {
        console.log(res);
        return res.data;
      })
      .catch((e: any) => {
        console.error("Error when trying to delete shift", e);
        let errorMessage = "Unknown error occurred";

        if (e.response && e.response.data) {
          errorMessage = e.response.data.message;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });

        return Promise.reject({
          ...e,
          errorMessage,
        });
      });
  };

const removeCompanyUser =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, userId: number): Promise<any> => {
    return Api()
      .company.deleteCompanyUser(companyId, userId)
      .then(() => {
        dispatch({ type: "REMOVE_COMPANY_USER", payload: userId });
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when deleting company User", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

const removeCompanyFavorite =
  (dispatch: CompanyDispatch) =>
  async (companyId: number, workerId: number): Promise<any> => {
    return Api()
      .company.removeCompanyFavorites(companyId, workerId)
      .then(() => {
        dispatch({ type: "REMOVE_COMPANY_FAVORITE", payload: workerId });
        return Promise.resolve();
      })
      .catch((e: Error) => {
        console.error("Error when removing favorite", e);
        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: "", err: e },
        });
        return Promise.reject();
      });
  };

export const companyActions = (
  dispatch: CompanyDispatch,
  state: CompanyState
) => ({
  saveCompany: saveCompany(dispatch),
  getCompany: getCompany(dispatch),
  getCompanyImage: getCompanyImage(dispatch),
  updateCompanyImage: updateCompanyImage(dispatch),
  addCompanyFavorite: addCompanyFavorite(dispatch),
  removeCompanyFavorite: removeCompanyFavorite(dispatch),
  switchCompany: switchCompany(dispatch),
  addCompanyUser: addCompanyUser(dispatch),
  updateCompanyUser: updateCompanyUser(dispatch),
  removeCompanyUser: removeCompanyUser(dispatch),
  getAvailableTimeReportsForStamping:
    getAvailableTimeReportsForStamping(dispatch),
  handleCheckInCheckOut: handleCheckInCheckOut(dispatch),
  handleDeleteCalenderShift: handleDeleteCalenderShift(dispatch),
  getStampClockTemplate: getStampClockTemplate(dispatch),
  updateStampClockTemplate: updateStampClockTemplate(dispatch),
  getLocalStampClockOnlySetting: getLocalStampClockOnlySetting(dispatch),
  updateStampClockLocalOnlySetting: updateStampClockLocalOnlySetting(dispatch),
  getAutogenerateShiftSetting: getAutogenerateShiftSetting(dispatch),
  updateAutogenerateShiftSetting: updateAutogenerateShiftSetting(dispatch),
  createAutoGeneratedGig: createAutoGeneratedGig(dispatch),
  getWorkerDetailsByWorkerId: getWorkerDetailsByWorkerId(dispatch),
});
